import { useEffect, useRef } from 'react';
import { useSocket } from '../context/SocketContext';

/** Subscribe to one Socket.IO event on the shared connection. */
export function useSocketEvent(event, callback) {
  const { socket } = useSocket();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!socket || !event) return undefined;

    const handler = (...args) => callbackRef.current?.(...args);
    socket.on(event, handler);
    return () => socket.off(event, handler);
  }, [socket, event]);
}
